import InterWebviewBridge, {
  interWbSession,
  interWbHttp,
  IWbHttpOptions,
  IWbHttpData,
  WbEnvironments,
  IWbAppInfo,
} from '@interco/inter-webview-bridge'
import { isMobile } from '@inter/lib-util'

import * as Types from './types'

export { interWbNavigate } from '@interco/inter-webview-bridge'

export const iWb = InterWebviewBridge.getInstance()
export const inApp = iWb.getEnvironment() !== WbEnvironments.BROWSER

const isAndroid = (): boolean => /Android/i.test(navigator.userAgent)

export const getPlatform = () => {
  if (!isMobile()) return 'Web'

  if (isAndroid()) {
    return 'Android'
  }
  return 'iPhone'
}

export const checkFeature = async (featureName: string): Promise<Types.CheckFeature> => {
  if (inApp) {
    return iWb.execute<Types.CheckFeature, unknown>({
      action: Types.Actions.CHECK_FEATURE,
      metadata: { featureName },
    })
  }

  return Promise.resolve({ isEnabled: true })
}

export const appInfo = async (): Promise<IWbAppInfo> => {
  if (inApp) {
    const resp = await interWbSession.getAppInfo()
    if (resp) {
      return resp
    }
  }
  const respMock: IWbAppInfo = {
    dimensions: {
      height: 1647,
      width: 1080,
    },
    nomeTipo: '',
    theme: '',
    version: '',
    appVersion: '',
    isDarkMode: false,
    deviceType: 'SMARTPHONE',
    application: 'PF',
    organization: 'PF',
    language: 'pt-BR',
    env: 'prod',
  }
  return Promise.resolve(respMock)
}

export const getSuperAppType = async (): Promise<'PF' | 'PJ'> => {
  if (inApp) {
    const resp = await interWbSession.getAppInfo()
    if (resp) {
      return resp.application
    }
  }
  return Promise.resolve('PF')
}
export const shareWebState = (): Promise<void> => {
  if (inApp) {
    return iWb.execute<void, undefined>({
      action: Types.Actions.SHARE_WEB_VIEW_SCREENSHOT,
    })
  }

  return Promise.resolve(undefined)
}

export const requestAnalytics = (name: string, params?: Record<string, string>) => {
  if (!inApp) return
  interWbSession.requestAnalytics(name, params)
}

export async function request<T = Record<string, unknown>>({
  method,
  endpoint,
  ...args
}: Types.Request): Promise<T> {
  let response: IWbHttpData
  const headers = args.headers || {}
  const options: IWbHttpOptions = { timeout: 30_000, ...args.options }

  switch (method) {
    default:
    case 'GET':
    case 'DELETE':
      response = await interWbHttp[method.toLowerCase() as 'get' | 'delete'](
        endpoint,
        headers,
        options,
      )
      break

    case 'POST':
    case 'PUT':
      response = await interWbHttp[method.toLowerCase() as 'post' | 'put'](
        endpoint,
        (args as Types.PostOrPut).body,
        headers,
        options,
      )
      break
  }

  const data = response
  return JSON.parse(data.response || '[]')
}

export const navigateHome = async (): Promise<void> => {
  if (inApp) {
    return iWb.execute<void, undefined>({
      action: Types.Actions.NAVIGATE_TO_HOME,
    })
  }
  return Promise.resolve(undefined)
}
